module.exports = __webpack_public_path__ + "img/banner1-min-en.b2fdb4db.jpg";